import { render } from "./Reviews.vue?vue&type=template&id=5353a9aa"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ZyMall/components/single/Reviews.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5353a9aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5353a9aa', __exports__)) {
    api.reload('5353a9aa', __exports__)
  }
  
  module.hot.accept("./Reviews.vue?vue&type=template&id=5353a9aa", () => {
    api.rerender('5353a9aa', render)
  })

}


export default __exports__